function trapFocus(element) {
  const focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"]:not([disabled])');
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;
  const body = document.querySelector('[data-body]');

  window.retainedFocus = document.activeElement;

  if (body.classList.contains('tabbing')) {
    firstFocusableEl.focus();
  }
  

  element.addEventListener('keydown', function(e) {
    const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) { return; }

    if ( e.shiftKey ) /* shift + tab */ {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else /* tab */ {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}

function removeTrapFocus(element) {
  const focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"]:not([disabled])');
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;
  const body = document.querySelector('[data-body]');

  if (body.classList.contains('tabbing')) {
    window.retainedFocus.focus();
  }

  window.retainedFocus = document.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [tabindex="0"]:not([disabled])')[0];

  element.removeEventListener('keydown', function(e) {
    const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) { return; }

    if ( e.shiftKey ) /* shift + tab */ {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else /* tab */ {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}

function initShopMenu() {
  const shopMenuTrigger = document.querySelector('[data-open-menu]');
  const shopMenu = document.querySelector('[data-shop-menu]');
  const body = document.querySelector('[data-body]');

  if (shopMenu === null || shopMenuTrigger === null) { return; }

  closeButton = shopMenu.querySelector('[data-close-shop-menu]');

  shopMenuTrigger.addEventListener('click', () => {
    body.classList.toggle('menu-open');
    shopMenu.classList.toggle('active');

    if (shopMenu.classList.contains('active')) {
      shopMenu.querySelectorAll('a, [data-close-shop-menu]').forEach(element => {
        element.removeAttribute('disabled');
        element.setAttribute('tabindex', '0');
      });
      trapFocus(shopMenu);
    } else {
      removeTrapFocus(shopMenu);
    }
  });

  shopMenuTrigger.addEventListener('keydown', (event) => {
    if (event.keyCode !== 13) { return; }

    body.classList.toggle('menu-open');
    shopMenu.classList.toggle('active');

    if (shopMenu.classList.contains('active')) {
      shopMenu.querySelectorAll('a, [data-close-shop-menu]').forEach(element => {
        element.removeAttribute('disabled');
        element.setAttribute('tabindex', '0');
      });
      trapFocus(shopMenu);
    } else {
      removeTrapFocus(shopMenu);
    }
  });

  closeButton.addEventListener('click', () => {
    closeMenu();
  });

  closeButton.addEventListener('keydown', (event) => {
    if (event.keyCode !== 13) { return; }

    closeMenu();
  });

  function closeMenu() {
    body.classList.remove('menu-open');
    shopMenu.classList.remove('active');
    removeTrapFocus(shopMenu);
    shopMenu.querySelectorAll('a, [data-close-shop-menu]').forEach(element => {
      element.setAttribute('disabled', '');
      element.setAttribute('tabindex', '-1');
    });
  }
}

function initTabbing() {
  const body = document.querySelector('[data-body]');

  document.addEventListener('keydown', function (e) {
    if (e.keyCode !== 9 || body.classList.contains('tabbing')) { return; }

    body.classList.add('tabbing');
  });
}

function initMobileMenu() {
  const hamburger = document.querySelector('[data-hamburger]');
  const mobileMenu = document.querySelector('[data-shop-menu-mobile]');
  const body = document.querySelector('[data-body]');
  if (hamburger === null || mobileMenu === null) { return; }

  const closeButton = mobileMenu.querySelector('[data-close-shop-menu-mobile]');

  hamburger.addEventListener('click', () => {
    mobileMenu.classList.add('active');
    body.classList.toggle('menu-open');
  });

  closeButton.addEventListener('click', () => {
    mobileMenu.classList.remove('active');
    body.classList.remove('menu-open');
  });
}

function initMobileShop() {
  const openMobileShop = document.querySelector('[data-open-mobile-shop]');
  const mobileShop = document.querySelector('[data-mobile-shop]');

  if (openMobileShop === null || mobileShop === null) { return; }

  openMobileShop.addEventListener('click', () => {
    openMobileShop.classList.toggle('active');
    mobileShop.classList.toggle('active');
  });

  const mobileShopSubItems = mobileShop.querySelectorAll('[data-open-mobile-sub-shop]');
  mobileShopSubItems.forEach(mobileShopSubItem => {
    mobileShopSubItem.addEventListener('click', () => {
      const handle = mobileShopSubItem.getAttribute('data-open-mobile-sub-shop');
      const elem = mobileShop.querySelector(`[data-mobile-sub-shop="${handle}"]`);

      if (elem === null) { return; }

      mobileShopSubItem.classList.toggle('active');
      elem.classList.toggle('active');
    });
  });
}

function initScrollNavDetection() {
  const nav = document.querySelector('[data-site-nav]');
  if (nav === null) { return; }

  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 80 || document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
      nav.classList.add('scrolled');
    } else {
      nav.classList.remove('scrolled');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initTabbing();
  initShopMenu();
  initMobileMenu();
  initMobileShop();
  initScrollNavDetection();
});
